var React = require('react');

function Vial (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M412.7 199.2L355.8 256H154.9l157.4-157.2c6.256-6.246 6.258-16.38 .0078-22.63c-6.246-6.246-16.37-6.25-22.62-.0078l-256.8 256.4c-38.75 38.75-45.13 102-9.375 143.5C44.08 500 72.76 512 101.5 512h.4473c26.38 0 52.75-10 72.88-30.12l260.5-260c6.26-6.246 6.264-16.38 .0117-22.64C429.1 192.1 418.1 192.1 412.7 199.2zM152.2 459.2C138.8 472.6 120.1 480 101.5 480c-20.59 0-40.15-9.014-53.68-24.76c-23.93-27.78-20.53-71.7 7.744-99.97L122.9 288h200.9L152.2 459.2zM507.3 180.7l-176-176C328.2 1.562 324.1 0 320 0s-8.188 1.562-11.31 4.688c-6.25 6.25-6.25 16.38 0 22.62l176 176C487.8 206.4 491.9 208 496 208s8.188-1.562 11.31-4.688C513.6 197.1 513.6 186.9 507.3 180.7z"}));
}

Vial.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Vial;

Vial.default = Vial;
